import { DownloadIcon } from "assets/icons";
import { QRCodeCanvas } from "qrcode.react";
import { useTranslation } from "react-i18next";
import { Button } from "ui";

import { downloadOrderPdf } from "../../../../helpers";
import { OrderAtomProps } from "../OrderModal.types";

export const DownloadDetailsBtn = ({ orderDetails }: OrderAtomProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <QRCodeCanvas
        value={orderDetails.id}
        id={`qr-${orderDetails.id}`}
        style={{ display: "none" }}
      />

      <Button
        type="button"
        title={t("Download QR & Details Sheet")}
        icon={<DownloadIcon width={24} height={24} />}
        variant="default"
        onClick={() => downloadOrderPdf([orderDetails])}
      />
    </div>
  );
};
